import { createContextValues } from '@connectrpc/connect';
import {
  type ListGlobalCloudProviderRegionsResponse,
  type ListGlobalCloudProvidersResponse,
  PlatformService,
} from '@qdrant/qdrant-cloud-public-api/platform/v1';
import {
  listGlobalCloudProviders,
  listGlobalCloudProviderRegions,
  listCloudProviders,
  listCloudProviderRegions,
  getCloudProviderRegion,
} from '@qdrant/qdrant-cloud-public-api/platform/v1/connect-query';
import { transport } from '@/api/transport';
import { createServiceQueries, type MessageInput, queryOptions } from '@/connect-query';
import { ctxKeyAuthorized } from '@/connect-query/context-keys';

// Data Transfer Objects
export type ListGlobalCloudProviderDto = MessageInput<ListGlobalCloudProvidersResponse['items'][number]>;
export type ListGlobalCloudProvidersDto = ListGlobalCloudProviderDto[];
export type ListGlobalCloudProviderRegionDto = MessageInput<ListGlobalCloudProviderRegionsResponse['items'][number]>;
export type ListGlobalCloudProviderRegionsDto = ListGlobalCloudProviderRegionDto[];

const contextValues = createContextValues().set(ctxKeyAuthorized, false);

export const platformService = createServiceQueries(PlatformService, {
  getCloudProviderRegionQuery: (params) => queryOptions(getCloudProviderRegion, params, { transport }),
  listCloudProviderRegionsQuery: (params) => queryOptions(listCloudProviderRegions, params, { transport }),
  listCloudProvidersQuery: (params) => queryOptions(listCloudProviders, params, { transport }),
  listGlobalCloudProviderRegionsQuery: (params) =>
    queryOptions(listGlobalCloudProviderRegions, params, { transport, contextValues }),
  listGlobalCloudProvidersQuery: () =>
    queryOptions(
      listGlobalCloudProviders,
      {},
      {
        transport,
        contextValues,
      },
    ),
});
